module.exports = __webpack_public_path__ + "static/media/profile.52b1eb3c.svg";